import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class SectionWrapper extends Component {
    static propTypes = {
        bgColor: PropTypes.oneOf([
            "grey",
            "white",
            "dark-blue",
            "blue",
            "grey-ink"
        ]),
        bigSpacing: PropTypes.bool,
        withButton: PropTypes.bool,
        noBottom: PropTypes.bool,
        children: PropTypes.node,
        title: PropTypes.string,
        centerTitle: PropTypes.bool,
        id: PropTypes.string,
        topRightComponent: PropTypes.node,
        buttonComponent: PropTypes.node
    };

    render() {
        const {
            bgColor,
            children,
            id,
            bigSpacing,
            withButton,
            noBottom,
            title,
            centerTitle,
            topRightComponent,
            buttonComponent
        } = this.props;

        return (
            <section
                id={id}
                className={classNames(
                    "section-wrapper",
                    bgColor && `section-wrapper--bg-${bgColor}`,
                    {
                        "section-wrapper--with-button": withButton,
                        "section-wrapper--spacing-big": bigSpacing,
                        "section-wrapper--no-bottom": noBottom
                    }
                )}
            >
                <div className="section-wrapper__inner">
                    {title && (
                        <div
                            className={classNames("section-wrapper__title", {
                                "section-wrapper__title--center": centerTitle
                            })}
                        >
                            {title}
                        </div>
                    )}

                    {topRightComponent && (
                        <div className="section-wrapper__topright">
                            {topRightComponent}
                        </div>
                    )}

                    <div className="section-wrapper__content">{children}</div>

                    {buttonComponent && (
                        <div className="section-wrapper__button">
                            {buttonComponent}
                        </div>
                    )}
                </div>
            </section>
        );
    }
}

export default SectionWrapper;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/SectionWrapper.js